import BirlExercise from 'models/birl/exercise'
import getModelMember from 'braindamage/api/getModelMember'
import { useQuery } from '@tanstack/react-query'

export default ({ birlExerciseId }) => {
  return useQuery({
    queryKey: ['birl_exercise', birlExerciseId],
    queryFn: async () => {
      const data = await getModelMember(
        `/api/birl/exercises/${birlExerciseId}`,
        BirlExercise
      )
      return data
    }
  })
}
